import { Component, ElementRef, inject, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../../services/http-service.service';
import { Subscription } from 'rxjs';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { NgbAccordionModule, NgbCarouselModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService } from '../../services/loading.service';
import { Offcanvas } from 'bootstrap';
import { LocalStorageService } from '../../services/local-storage.service';
import { USER_PERMISSIONS } from '../../app.constants';

@Component({
  selector: 'app-create-inspection',
  imports: [ReactiveFormsModule, BreadcrumbComponent, NgFor, NgClass, NgbAccordionModule, NgbCarouselModule, NgIf, DatePipe],
  templateUrl: './create-inspection.component.html',
  styleUrl: './create-inspection.component.css'
})
export class CreateInspectionComponent {
  breadcrumbList = {
    breadcrumb_path: 'Inspections',
    currentURL: 'Create Inspection',
    breadcrumb_url: '/admin/inspections'
  }
  inspectionId: string = '';

  private routeSubscription?: Subscription;
  private getRoomInspectionsSubscription?: Subscription;
  private getAllRoomItemsSubscription? : Subscription;
  private saveRoomItemsSubscription?:Subscription;
  private getInspectionRoomItemsSubscription?:Subscription;
  private deleteInspectionImageSubscription?: Subscription;
  private inspectionRoomDeleteSubscription?: Subscription;
  private updateInspectionConditionSubsscription?: Subscription;
  private getInspectionDetailsByIdSubscription? : Subscription;
  private createInspectionSubscription? : Subscription;
  add_room: boolean = false;
  editRoomItemsForm!: FormGroup;
  filteredRoomsList: any = [];
  filteredItems: any = [];
  roomsForm!: FormGroup;
  editInspectionForm!: FormGroup;
  loadingService = inject(LoadingService);  
  private modalService= inject(NgbModal);
    theme : any = [{ hedingClass: 'accordion-primary' }];
    themeClass: any = '';
    maneClass: string = '';
    positionClass: string = '';
    iconClass: string = '';
    bg: string = '';
    inspectionImages : any = [];
    @ViewChild('addEditRoom') offcanvas!: ElementRef;
    private offcanvasInstance: Offcanvas | null = null; 
    isRoomEdit : boolean = false;
    private authService = inject(LocalStorageService);
    defaultInspectionStatus : string[] =  ["Good", "Fair", "Bad" , "Repair"];
    selectedFiles: File[] = [];
    selectedItem : any;
  queryParamsSubsscription?: Subscription;
  queryParamsData: any;
  inspectionDetails : any;

  constructor(private route: ActivatedRoute, private fb: FormBuilder, private alertService: NgxToastrService, private httpService: HttpServiceService, private router: Router) {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.inspectionId = params.get('id') ?? "";
    });
    this.editInspectionForm = this.fb.group({
      inspection_name : [''],      
      inspection_notes : [''],
      // inspection_status : [null]
    });
    this.editInspection(this.inspectionId);
  }

  ngOnInit() {
    this.getAllRoomItems("1");
    this.roomItemsForm();
    this.getInspectionRooms();
    this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any) => {
      this.queryParamsData = data;
    });
  }

  getInspectionRooms(){
    this.getRoomInspectionsSubscription = this.httpService.getRoomsByInspectionId(this.inspectionId).subscribe({
      next: (response) => {        
        this.initRooms(response.data);
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const offcanvasElement = this.offcanvas?.nativeElement;
      if (offcanvasElement) {
        this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    });
  }

  roomItemsForm(){
    this.editRoomItemsForm = this.fb.group({
      editrooms: this.fb.array([])
    });
  }

  getAllRoomItems(propertyId : string){
    this.getAllRoomItemsSubscription = this.httpService.getAllPropertyItems(propertyId).subscribe({
      next : (response) => {
        this.filteredItems =  response.data;        
        this.filteredRoomsList = [...response.data];
        this.createRoomForm();
      }
    })
  }

  initRooms(inspectionsRoomsList : any = []) {    
    inspectionsRoomsList.forEach((room: {id : string, room_name: any; room_items: any[]; }) => {
      const roomGroup = this.fb.group({
        id : [room.id],
        room_name: [room.room_name],
        items: this.fb.array(
          room.room_items.map(item =>
            this.fb.group({
              id: [item.id],
              item_name: [item.item_name],
              item_quantity: [item.item_quantity ?? ''],
              item_condition: [item.item_condition ?? null],
              item_notes : [item.item_notes ? item.item_notes : ''],
              item_uploads : [item.item_uploads],
            })
          )
        )
      });
      this.editrooms.push(roomGroup);
    });
  }

  createRoomForm(){
      this.roomsForm = this.fb.group({
        uid : this.fb.control(''),
        searchText : this.fb.control(''),
        room_name : this.fb.control('', Validators.required),
        selectedItems: this.fb.array(this.filteredItems.map(() => this.fb.control(false)),
        this.minOneCheckboxChecked())  // FormArray for checkboxes
      });
    }
  
    minOneCheckboxChecked(): ValidatorFn {
      return (control: AbstractControl) => {
        const formArray = control as FormArray;
        return formArray.controls.some(ctrl => ctrl.value) ? null : { required: true };
      };
    }
  
    filterItems() {
      const control = this.roomsForm?.get("searchText");   
      if (!control?.value) {
        this.filteredItems = this.filteredRoomsList;
      } else {
        this.filteredItems = this.filteredRoomsList.filter((item: { name: string; }) =>
          item.name.toLowerCase().includes(control?.value?.toLowerCase())
        );
      }
    }

  getSelectedRoomItems() {
    const selectedItems: string[] = [];
    this.allFormControls?.controls.forEach((control, index) => {
      if (control.value) {   
        selectedItems.push(this.filteredRoomsList[index].id);
      }
    });
    return selectedItems;
  }

  saveRoomItems() {

  }

  deletePropertyRoom(roomId: string) {
    this.inspectionRoomDeleteSubscription = this.httpService.deleteInspectionRoom(this.inspectionId, roomId).subscribe({
      next: (response) => {
        this.roomItemsForm();
        this.getInspectionRooms();
        this.alertService.success(response.message, "toast-top-right");
      }
    });
  }

  showHideEditRoom(roomId : string, room_name : string){
    this.isRoomEdit = true;
    this.getRoomDetailsByInspectionId(roomId, room_name); 
  }

  getRoomDetailsByInspectionId(roomId : string, room_name : string){
    this.getInspectionRoomItemsSubscription = this.httpService.getInspectionRoomItems(this.inspectionId, roomId).subscribe({
      next : (response) => {
        this.roomsForm.patchValue({room_name : room_name, uid : roomId});      
        this.setRoomCheckboxes(response.data ?? []);
        this.showHideRoom();
      }
    })
  }

  setRoomCheckboxes(roomItems : any) {
      this.allFormControls?.controls.forEach((control, index) => {      
        let isChecked = roomItems.find((role:any) => role == this.filteredRoomsList[index]?.id) ? true : false;
        if(isChecked) {
          control.setValue(true);
        }else{
          control.setValue(false);
        }
      });
  }

  getItems(roomIndex: number): FormArray {
    return this.editrooms.at(roomIndex).get('items') as FormArray;
  }

  inspectionEvent(event: any) {
    this.router.navigate(['admin', 'inspections'],{
      queryParams : this.queryParamsData
    });
  }

  showHideRoom(){    
    this.add_room = !this.add_room;
    if (this.offcanvasInstance) {
        this.offcanvasInstance.show();
    }
  }

  addRoomClose(){
    this.showHideRoom();
    this.roomsForm.reset();
    this.isRoomEdit = false;
    if (this.offcanvasInstance) {
        this.offcanvasInstance.hide();
    }
  }

  saveRoom(){    
    if(!this.roomsForm.valid) return;
    let roomObj = this.roomsForm.value ?? {};    
    let obj = {
      room_name : roomObj["room_name"],
      items : this.getSelectedRoomItems()
    }
    if(this.isRoomEdit){
      this.saveRoomItemsSubscription = this.httpService.updateInspectionsRoom(this.inspectionId, roomObj.uid, obj).subscribe({
        next : (response) => {
          this.roomItemsForm();
          this.getInspectionRooms();
          this.addRoomClose();
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }else{
      this.saveRoomItemsSubscription = this.httpService.saveInspectionsRoom(this.inspectionId, obj).subscribe({
        next : (response) => {
          this.roomItemsForm();
          this.roomsForm.reset();
          this.addRoomClose();
          this.getInspectionRooms();
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }
  }

  updateInspectionNotes(roomId : string, itemId : string, item_notes : string, item : any, type : string){    
    const formData = new FormData();
    formData.append(type, item_notes);
    this.updateInspectionRoomItems(roomId, itemId, formData, item);
  }

  uploadImages(event: Event, roomId : string, itemId : string, item : any) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      this.selectedFiles = Array.from(inputElement.files);
    }
    if(!this.selectedFiles.length) return;
    const formData = new FormData();    
    this.selectedFiles.forEach((file, index) => {
      formData.append('files', file); // 'images' is the form field name
    });
    this.updateInspectionRoomItems(roomId, itemId, formData, item);
    inputElement.value = '';
  }

  updateInspectionCondition(roomId : string, itemId : string, itemName : string, condition : string, item : any){    
    const formData = new FormData();
    formData.append(itemName, condition);
    this.updateInspectionRoomItems(roomId, itemId, formData, item);
  }

  updateInspectionRoomItems(roomId : string, itemId : string, formData : any, item : any){
    this.updateInspectionConditionSubsscription = this.httpService.updateInspectionRoomItems(this.inspectionId, roomId, itemId, formData).subscribe({
      next : (response) => {  
        let image_uploads = response.data["item_uploads"] ?? [];      
        item.get('item_uploads')?.setValue(image_uploads);
        this.selectedFiles = [];
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  viewPropertyImage(content: TemplateRef<any>, images : any = [], item : any){
      this.inspectionImages = images; 
      this.selectedItem = item;
      this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }
  deleteInspectionImage(imageId : string){
    if (!confirm('Delete this image? This cannot be undone.')) return;
    this.deleteInspectionImageSubscription = this.httpService.deleteInspectionImage(imageId).subscribe({
      next : (response) => {
        this.inspectionImages = this.inspectionImages.filter((img : any) => img.id != imageId);
        this.selectedItem.get('item_uploads')?.setValue(this.inspectionImages);
        if(!this.inspectionImages.length) {
          this.modalService.dismissAll();
        }
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  editInspection(id: string) {
    this.getInspectionDetailsByIdSubscription  = this.httpService.getInspectionDetailsById(id).subscribe({
      next : (response) => {
        this.inspectionDetails = response.data;
        this.editInspectionForm.patchValue(response.data);
      }
    });
  }

  onSubmit(){
    //const formData = new FormData();
    // Object.keys(this.editInspectionForm.controls).forEach((key) => {
    //   let value = this.editInspectionForm.get(key)?.value;      
    //   if(value) formData.append(key, value);
    // });
    let obj = { notes : this.editInspectionForm.get("inspection_notes")?.value };
    this.createInspectionSubscription = this.httpService.updateInspectionStatus(this.inspectionId, obj).subscribe({
        next: (response) => {
          this.alertService.success(response.message, "toast-top-right");
        }
    });
  }


  ngOnDestroy() {    
    this.routeSubscription?.unsubscribe();
    this.getRoomInspectionsSubscription?.unsubscribe();
    this.getAllRoomItemsSubscription?.unsubscribe();
    this.saveRoomItemsSubscription?.unsubscribe();
    this.getInspectionRoomItemsSubscription?.unsubscribe();
    this.deleteInspectionImageSubscription?.unsubscribe();
    this.inspectionRoomDeleteSubscription?.unsubscribe();
    this.updateInspectionConditionSubsscription?.unsubscribe();
    this.getInspectionDetailsByIdSubscription?.unsubscribe();
    this.createInspectionSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
  }

  get editrooms(): FormArray {
      return this.editRoomItemsForm.get('editrooms') as FormArray;
  }

  get allFormControls() {
    return this.roomsForm?.get('selectedItems') as FormArray;
  }

  get checkInspectionAddRoom(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_ADD_ROOM);
  }

  get checkInspectionAddRoomItems(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_ADD_ROOM_ITEMS);
  }

  get checkInspectionDeleteRoom(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_DELETE_ROOM);
  }

  get checkLocationView(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_VIEW_LOCATION);
  }

}
